import React, { useCallback, useRef } from "react";
import { GeolocateControl as MapboxGeolocateControl } from "mapbox-gl";
import { useTranslation } from "react-i18next";
import { GeolocateControl } from "react-map-gl/mapbox-legacy";
import { MapTool } from "./MapTool";
import { MapToolLabel } from "./MapToolLabel";

export const GeolocationTool = ({
  geolocateClicked,
}: {
  geolocateClicked: () => Promise<void>;
}) => {
  const { t } = useTranslation();
  const geolocateControlRef = useRef<MapboxGeolocateControl>(null);

  const handleClick = useCallback(async () => {
    await geolocateClicked();
    geolocateControlRef.current?.trigger();
  }, [geolocateClicked]);

  return (
    <MapTool>
      <MapToolLabel label={t("button-show-location")} />
      {/* we don't want to show the Mapbox GeolocateControl because it
        will interfere render in a pre-defined position, but we need it
        to be rendered so that the trigger method is available
        so that the trigger method is available */}
      <GeolocateControl
        ref={geolocateControlRef}
        trackUserLocation
        fitBoundsOptions={{ maxZoom: 18, minZoom: 18 }}
        position="bottom-right"
        style={{ display: "none" }}
      />
      {/* we use mapbox class names to get the appearance of the button right
      while allowing us to position the button where we want it */}
      <div className="mapboxgl-ctrl mapboxgl-ctrl-group">
        <button
          className="mapboxgl-ctrl-geolocate"
          type="button"
          title={t("button-show-location")}
          aria-label={t("button-show-location")}
          onClick={handleClick}
        >
          <span className="mapboxgl-ctrl-icon" aria-hidden="true" />
        </button>
      </div>
    </MapTool>
  );
};
